export enum TSBegruendungsCode {
    BG_1 = <any>'BG_1',
    BG_10 = <any>'BG_10',
    BG_11 = <any>'BG_11',
    BG_12 = <any>'BG_12',
    BG_13 = <any>'BG_13',
    BG_14 = <any>'BG_14',
    BG_15 = <any>'BG_15',
    BG_16 = <any>'BG_16',
    BG_17 = <any>'BG_17',
    BG_18 = <any>'BG_18',
    BG_19 = <any>'BG_19',

    BG_20 = <any>'BG_20',
    BG_21 = <any>'BG_21',
    BG_22 = <any>'BG_22',
    BG_23 = <any>'BG_23',
    BG_24 = <any>'BG_24',
    BG_25 = <any>'BG_25',
    BG_26 = <any>'BG_26',
    BG_27 = <any>'BG_27',
    BG_28 = <any>'BG_28',
    BG_29 = <any>'BG_29',
    BG_30 = <any>'BG_30',
    BG_31 = <any>'BG_31',
    BG_32 = <any>'BG_32',
    BG_33 = <any>'BG_33',
    BG_34 = <any>'BG_34',
    BG_35 = <any>'BG_35',
    BG_36 = <any>'BG_36',
    BG_37 = <any>'BG_37',
    BG_38 = <any>'BG_38',
    BG_39 = <any>'BG_39',
    BG_40 = <any>'BG_40',
    BG_41 = <any>'BG_41',
    BG_42 = <any>'BG_42',
    BG_45 = <any>'BG_45',
    BG_46 = <any>'BG_46',
    BG_47 = <any>'BG_47',
    BG_48 = <any>'BG_48',
    BG_49 = <any>'BG_49',

    BG_50 = <any>'BG_50',
    BG_52 = <any>'BG_52',
    BG_54 = <any>'BG_54',
    BG_55 = <any>'BG_55',
    BG_56 = <any>'BG_56',
    BG_57 = <any>'BG_57',
    BG_58 = <any>'BG_58',
    BG_59 = <any>'BG_59',

    BG_80 = <any>'BG_80',
    BG_81 = <any>'BG_81',
    BG_82 = <any>'BG_82',
    BG_83 = <any>'BG_83',
    BG_84 = <any>'BG_84',
    BG_85 = <any>'BG_85',
    BG_86 = <any>'BG_86',

    BG_62 = <any>'BG_62',
    BG_76 = <any>'BG_76',
    BG_66 = <any>'BG_66',
    BG_69 = <any>'BG_69',

    BG_70 = <any>'BG_70',
    BG_71 = <any>'BG_71',
    BG_72 = <any>'BG_72',
    BG_73 = <any>'BG_73',
    BG_74 = <any>'BG_74',
    BG_75 = <any>'BG_75',

    BG_79 = <any>'BG_79',

    BG_87 = <any>'BG_87',
    BG_90 = <any>'BG_90',
    BG_91 = <any>'BG_91',
    BG_92 = <any>'BG_92',
    BG_93 = <any>'BG_93',
    BG_95 = <any>'BG_95',
    BG_98 = <any>'BG_98',

    /****************** Neue Begründungscodes ********************/
    BGN_10 = <any>'BGN_10',
    BGN_11 = <any>'BGN_11',
    BGN_12 = <any>'BGN_12',
    BGN_20 = <any>'BGN_20',
    BGN_21 = <any>'BGN_21',
    BGN_22 = <any>'BGN_22',
    BGN_23 = <any>'BGN_23',
    BGN_30 = <any>'BGN_30',
    BGN_31 = <any>'BGN_31',
    BGN_32 = <any>'BGN_32',
    BGN_33 = <any>'BGN_33',
    BGN_34 = <any>'BGN_34',
    BGN_40 = <any>'BGN_40',
    BGN_41 = <any>'BGN_41',
    BGN_42 = <any>'BGN_42',
    BGN_43 = <any>'BGN_43',

    BGN_60 = <any>'BGN_60',
    BGN_61 = <any>'BGN_61',
    BGN_62 = <any>'BGN_62',
    BGN_63 = <any>'BGN_63',
    BGN_64 = <any>'BGN_64',
    BGN_65 = <any>'BGN_65',
    BGN_66 = <any>'BGN_66',
    BGN_67 = <any>'BGN_67',
    BGN_68 = <any>'BGN_68',
    BGN_69 = <any>'BGN_69',
    BGN_70 = <any>'BGN_70',
    BGN_71 = <any>'BGN_71',
    BGN_72 = <any>'BGN_72',
    BGN_73 = <any>'BGN_73',
    BGN_80 = <any>'BGN_80',
    BGN_81 = <any>'BGN_81',
    BGN_82 = <any>'BGN_82',

    BGN_90 = <any>'BGN_90',
    BGN_91 = <any>'BGN_91',
    BGN_92 = <any>'BGN_92',
    BGN_93 = <any>'BGN_93',
    BGN_94 = <any>'BGN_94',
}

export function  getCodesFS(): Array<TSBegruendungsCode> {
    return [
        TSBegruendungsCode.BGN_10,
        TSBegruendungsCode.BGN_11,
        TSBegruendungsCode.BGN_12,
        TSBegruendungsCode.BGN_20,
        TSBegruendungsCode.BGN_21,
        TSBegruendungsCode.BGN_22,
        TSBegruendungsCode.BGN_23,
        TSBegruendungsCode.BGN_30,
        TSBegruendungsCode.BGN_31,
        TSBegruendungsCode.BGN_32,
        TSBegruendungsCode.BGN_33,
        TSBegruendungsCode.BGN_34,
        TSBegruendungsCode.BGN_40,
        TSBegruendungsCode.BGN_41,
        TSBegruendungsCode.BGN_42,
        TSBegruendungsCode.BGN_43,

        TSBegruendungsCode.BGN_60,
        TSBegruendungsCode.BGN_61,
        TSBegruendungsCode.BGN_62,
        TSBegruendungsCode.BGN_63,
        TSBegruendungsCode.BGN_64,
        TSBegruendungsCode.BGN_65,
        TSBegruendungsCode.BGN_66,
        TSBegruendungsCode.BGN_67,
        TSBegruendungsCode.BGN_68,
        TSBegruendungsCode.BGN_69,
        TSBegruendungsCode.BGN_70,
        TSBegruendungsCode.BGN_71,
        TSBegruendungsCode.BGN_72,
        TSBegruendungsCode.BGN_73,
        TSBegruendungsCode.BGN_80,
        TSBegruendungsCode.BGN_81,
        TSBegruendungsCode.BGN_82,

        TSBegruendungsCode.BGN_90,
        TSBegruendungsCode.BGN_91,
        TSBegruendungsCode.BGN_92,
        TSBegruendungsCode.BGN_93,
        TSBegruendungsCode.BGN_94,
    ];
}


export function getTSBegruendungsCode(): Array<TSBegruendungsCode> {
    return [

        TSBegruendungsCode.BG_1,
        TSBegruendungsCode.BG_10,
        TSBegruendungsCode.BG_11,
        TSBegruendungsCode.BG_12,
        TSBegruendungsCode.BG_13,
        TSBegruendungsCode.BG_14,
        TSBegruendungsCode.BG_15,
        TSBegruendungsCode.BG_16,
        TSBegruendungsCode.BG_17,
        TSBegruendungsCode.BG_18,
        TSBegruendungsCode.BG_19,
        TSBegruendungsCode.BG_20,
        TSBegruendungsCode.BG_21,
        TSBegruendungsCode.BG_22,
        TSBegruendungsCode.BG_23,
        TSBegruendungsCode.BG_24,
        TSBegruendungsCode.BG_25,
        TSBegruendungsCode.BG_26,
        TSBegruendungsCode.BG_27,
        TSBegruendungsCode.BG_28,
        TSBegruendungsCode.BG_29,
        TSBegruendungsCode.BG_30,
        TSBegruendungsCode.BG_31,
        TSBegruendungsCode.BG_32,
        TSBegruendungsCode.BG_33,
        TSBegruendungsCode.BG_34,
        TSBegruendungsCode.BG_35,
        TSBegruendungsCode.BG_36,
        TSBegruendungsCode.BG_37,
        TSBegruendungsCode.BG_38,
        TSBegruendungsCode.BG_39,
        TSBegruendungsCode.BG_40,
        TSBegruendungsCode.BG_41,
        TSBegruendungsCode.BG_42,
        TSBegruendungsCode.BG_45,
        TSBegruendungsCode.BG_46,
        TSBegruendungsCode.BG_47,
        TSBegruendungsCode.BG_48,
        TSBegruendungsCode.BG_49,
        TSBegruendungsCode.BG_50,
        TSBegruendungsCode.BG_52,
        TSBegruendungsCode.BG_54,
        TSBegruendungsCode.BG_55,
        TSBegruendungsCode.BG_56,
        TSBegruendungsCode.BG_57,
        TSBegruendungsCode.BG_58,
        TSBegruendungsCode.BG_59,
        TSBegruendungsCode.BG_80,
        TSBegruendungsCode.BG_81,
        TSBegruendungsCode.BG_82,
        TSBegruendungsCode.BG_83,
        TSBegruendungsCode.BG_84,
        TSBegruendungsCode.BG_85,
        TSBegruendungsCode.BG_86,
        TSBegruendungsCode.BG_62,
        TSBegruendungsCode.BG_76,
        TSBegruendungsCode.BG_66,
        TSBegruendungsCode.BG_69,
        TSBegruendungsCode.BG_70,
        TSBegruendungsCode.BG_71,
        TSBegruendungsCode.BG_72,
        TSBegruendungsCode.BG_73,
        TSBegruendungsCode.BG_74,
        TSBegruendungsCode.BG_75,
        TSBegruendungsCode.BG_79,
        TSBegruendungsCode.BG_87,
        TSBegruendungsCode.BG_90,
        TSBegruendungsCode.BG_91,
        TSBegruendungsCode.BG_92,
        TSBegruendungsCode.BG_93,
        TSBegruendungsCode.BG_95,
        TSBegruendungsCode.BG_98,
    ];
}

export function begruendungsCodePrefix(): string {
    return 'TSBegruendungsCode_';
}

export function begruendungsCodeShortPostfix(): string {
    return '_kurz';
}

export function begruendungsCodeLongPostfix(): string {
    return '_lang';
}



// WEBPACK FOOTER //
// ./src/app/models/enums/TSBegruendungsCode.ts